<template>
  <div class="category" v-if="items.length">
    <div class="category-item" :class="{'category-top': index < 5}" v-for="(category, index) in items" :key="category.id" @click="goPage(category, index)">
      <vanImg class="catetory-img" :src="category.iconUrl | imageToHttps | imageToWebp($webpSurpport)" alt=""/>
      <span :style="{'color': category.fontColor}">{{category.name}}</span>
    </div>
    <div class="category-mask" :style="{'background': bgColor,'opacity': bgOpacity, 'background-size': '100% 100%'}"></div>
  </div>
</template>

<script>
import { PlatformTypes } from '@/config/constMaps'

export default {
  name: 'categoryItems',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    bgColor: {
      type: String,
      default: '#fff'
    },
    bgOpacity: {
      type: Number,
      default: 1
    }
  },
  methods: {
    goPage(item, index) {
      console.log(item)
      // 埋点
      this.$util.gioTrackWithVariable('MB15593', {
        site_number: index + 1 + '',
        text: item.name || 'null'
      })
      this.$util.trackWithVariable({
        platformConf: {
          [PlatformTypes.INTERNAL_CHANNEL]: {
            id: 'IH20023',
            param: ['roughly_classification_name']
          },
        },
      }, {
        roughly_classification_name: item.name || 'null'
      }).then(res => {
        console.log('report res', res)
      })
      if (item.hyperType === undefined) {
        this.$store.dispatch('bannerTypeFiveClick', { hyperLink: item.linkUrl });
      } else {
        this.$store.dispatch('goPageByType', {
          type: item.hyperType,
          params: item.hyperParam
        })
      }

      // if (item.linkUrl.includes('.ehaier.com/sgmobile')) {
      //   this.$router.push(item.linkUrl.split('.ehaier.com/sgmobile')[1])
      // } else {
      //   location.href = item.linkUrl
      // }
      // this.$router.push(item.linkUrl, false, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.category{
  margin: .24rem .32rem;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  border-radius: .24rem;
  padding-top: .38rem;
  position: relative;
  transform: translateZ(0);
  .category-mask{
    width: 100%;
    height: 100%;
    opacity: 0.7;
    position: absolute;
    z-index: 5;
    left: 0;
    top: 0;
  }
}

.category-item{
  width: 1.37rem;
  // height: 1.72rem;
  margin-bottom: .4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 9;
  position: relative;
  .catetory-img{
    margin-bottom: .04rem;
    width: .84rem;
    height: .84rem;
    border-radius: .24rem;

    :deep(img) {
    -webkit-touch-callout: none;
    pointer-events: none;
    }
  }
  span{
    display: inline-block;
    width: 100%;
    font-size: .24rem;
    color: #111111;
    text-align: center;
    line-height: .3rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
  }
}
.category-top{
  .catetory-img{
    margin-top: .08rem;
  }
}
</style>
